<template>
  <div class="contenedor-selector selector-estatal">
    <div class="selector icon-select" 
      v-on:click="abrirLista=!abrirLista"
    >{{ placeholder }}</div>

    <div class="contenedor-lista lista-municipal" 
      v-bind:class="{'abrir-lista': abrirLista}">
      <div class="contenedor-lista-opciones">
        <button class="btn-limpiar-lista"
          v-bind:class="{'disabled': seleccion.length==0}"
          v-on:click="limpiarSeleccion()"
        >Limpiar selección</button>

        <button class="btn-cerrar-lista"
          v-on:click="abrirLista=false"
        >&times;</button>
      </div>

      <div class="item" v-for="estado in estados"
        :key="estado.cve_ent">
        <input type="checkbox" v-bind:id="estado.cve_ent" 
          v-bind:value="estado.cve_ent"
          v-model="seleccion"
          @change="cambiarSeleccion()">
        <label v-bind:for="estado.cve_ent">{{ estado.nom_ent }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import Estados from '@/components/mapa/capas/Estados.js';

const placeholderInicial = 'Estado';

export default {
  data() {
    return {
      placeholder: placeholderInicial,
      abrirLista: false,
      estados: [],
      seleccion: [],
    };
  },
  mounted() {
    const estados = new Estados();
    estados.wfs.columnas = 'nom_ent';
    estados.wfs.orden = 'nom_ent';
    estados.wfs.cargarPropiedades.then(data => {
      this.estados = data;
    });
  },
  methods: {
    ...mapMutations(['cambiarMapaModo',
      'reiniciarMapaModo','cambiarMapaCvesEdo',]),
    limpiarSeleccion() {
      this.seleccion = [];
      this.reiniciarMapaModo();
    },
    cambiarSeleccion() {
      // console.log('cambiarSeleccion()');
      if (this.seleccion.length == 0) {
        this.limpiarSeleccion();
      } else {
        // sólo si no hay municipios seleccionados
        this.cambiarMapaModo('estatal');
        this.cambiarMapaCvesEdo(this.seleccion);
      }
    },
    actualizarPlaceholder() {
      if (this.seleccion.length == 0){
        this.placeholder = placeholderInicial;
      } else if (this.seleccion.length == 1) {
        this.placeholder = this.estados
          .find(edo => edo.cve_ent===this.seleccion[0]).nom_ent;
      } else {
        this.placeholder = 'Selección multiple';
      }
    },
  },
  computed: {
    ...mapGetters(['actualMapaModoYCves',]),
  },
  watch: {
    actualMapaModoYCves(actual) {
      if (actual.modo === 'inicial') {
        this.seleccion = [];
      } else { // estatl o municipal
        this.seleccion = actual.cvesEdo;
      }
      this.actualizarPlaceholder();
    },
  },
}
</script>

<style lang="scss">
.selector-estatal {
  .selector {
    // padding-right: 2.5em !important;
    text-align: left !important;
    display: block;
    font-size: 16px;
    &:hover {
      box-shadow: 0 3px 9px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
